import { api, api_base } from "../../api";

export const USER_API_END_POINT=api+"/user";
export const JOB_API_END_POINT=api+"/offer";
export const APPLICATION_API_END_POINT=api+"/application";
export const ENROLMENT_API_END_POINT=api+"/enrolment";
export const COMPANY_API_END_POINT=api+"/recruiter";
export const TRAINING_API_END_POINT =api+"/training";
export const TRAINER_API_END_POINT =api+"/trainer";
export const CANDIDATE_API_END_POINT =api+"/candidate";
export const REQUEST_API_END_POINT =api+"/request";
export const RESUME_API_END_POINT =api+"/resume";
export const API_END_POINT = api;
export const END_POINT = api_base;
// photo api end point
export const CANDIDATE_IMAGE_URL_END_POINT =api_base+"/storage/candidate";
export const COMPANY_IMAGE_URL_END_POINT =api_base+"/storage/company";
export const JOB_IMAGE_URL_END_POINT =api_base+"/storage/offer";
export const TRAINING_IMAGE_URL_END_POINT =api_base+"/storage/training";
export const TRAINER_IMAGE_URL_END_POINT =api_base+"/storage/trainer";
export const IMAGE_PATH =api_base+"/storage";
export const USER_IMAGE_URL_END_POINT =api_base+"/storage";